(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@spiky-panda/core"), require("murmuration-core"), require("@babylonjs/core"));
	else if(typeof define === 'function' && define.amd)
		define(["@spiky-panda/core", "murmuration-core", "@babylonjs/core"], factory);
	else if(typeof exports === 'object')
		exports["MurmurationBabylon"] = factory(require("@spiky-panda/core"), require("murmuration-core"), require("@babylonjs/core"));
	else
		root["MurmurationBabylon"] = factory(root["SpikyPandaCore"], root["MurmurationCore"], root["BABYLON"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__854__, __WEBPACK_EXTERNAL_MODULE__487__, __WEBPACK_EXTERNAL_MODULE__905__) => {
return 